import {
  GI_MMT_CABIN_CLASS_MAP,
  GI_MMT_FARE_TYPE_MAP,
  GI_MMT_FARE_TYPE_MAP_NEW
} from '@stencil/flights-constants/src/params-values';

const getSrpUrlParams = (flightSearchData, isGroundup = false, selectedFareIdentifier = '') => {
  const { source, destination, departure, arrival, passengers, flightClass, travelType, flavour } =
    flightSearchData;
  const EMPTY_STRING = '';
  const DOMESTIC = 'domestic';
  const DOMESTIC_TYPE = 'D';
  const INTERNATIONAL_TYPE = 'I';
  const isDomestic = travelType === DOMESTIC;
  if (flavour === 'PWA') {
    return `${source.iata}-${destination.iata}-${departure.yyyymmdd}-${
      arrival ? arrival.yyyymmdd : EMPTY_STRING
    }-${passengers.adult}-${passengers.child}-${passengers.infant}-${flightClass.value}-${
      selectedFareIdentifier ? selectedFareIdentifier : 'R'
    }`;
  }

  const urlParams = `${source.iata}-${destination.iata}-${departure.yyyymmdd}-${
    arrival ? arrival.yyyymmdd : EMPTY_STRING
  }-${passengers.adult}-${passengers.child}-${passengers.infant}-${flightClass.value}-${
    isDomestic ? DOMESTIC_TYPE : INTERNATIONAL_TYPE
  }`;

  return urlParams;
};

const formateDate = date => {
  const formattedDate =
    date.getDate().toString().padStart(2, '0') +
    '/' +
    (date.getMonth() + 1).toString().padStart(2, '0') +
    '/' +
    date.getFullYear();
  return formattedDate;
};

export const getUnifiedSrpUrlParams = (
  flightSearchData,
  selectedFareIdentifier = '',
  extraQueryParams = {}
) => {
  const { source, destination, departure, arrival, passengers, flightClass, travelType, flavour } =
    flightSearchData;
  const isDomestic = travelType === 'domestic';

  let urlParams = `itinerary=${source.iata}-${destination.iata}-${formateDate(departure.dateObj)}${
    arrival ? `_${destination.iata}-${source.iata}-${formateDate(arrival.dateObj)}` : ''
  }&tripType=${arrival ? 'R' : 'O'}&paxType=A-${passengers.adult}_C-${passengers.child}_I-${
    passengers.infant
  }&intl=${isDomestic ? 'false' : 'true'}&cabinClass=${
    GI_MMT_CABIN_CLASS_MAP[flightClass.value] || 'E'
  }&ccde=IN&lang=eng`;

  Object.keys(extraQueryParams || {}).forEach(key => {
    urlParams += `&${key}=${extraQueryParams[key]}`;
  });

  if (selectedFareIdentifier && GI_MMT_FARE_TYPE_MAP[selectedFareIdentifier]) {
    urlParams = `${urlParams}&pft=${GI_MMT_FARE_TYPE_MAP[selectedFareIdentifier]}`;
  } else if (selectedFareIdentifier && GI_MMT_FARE_TYPE_MAP_NEW[selectedFareIdentifier]) {
    urlParams = `${urlParams}&pft=${GI_MMT_FARE_TYPE_MAP_NEW[selectedFareIdentifier]}`;
  }

  return urlParams;
};

export default getSrpUrlParams;
